module.exports = __webpack_public_path__ + "img/icon-explore-add.a45b1e86.svg";